<template>
  <div class="leaf no-wrap" :title="item.label" @click="$emit('click', $event)" @mousedown="$emit('mousedown', $event)">
    <span :class="{ bold: item.isMatch }" v-for="(item, ind) in splitted" :key="ind"><template v-if="item.word.startsWith(' ')">&nbsp;</template>{{ item.word.trim() }}<template v-if="item.word.endsWith(' ')">&nbsp;</template></span>
    <span v-if="length">&nbsp;({{ length }})</span>
  </div>
</template>

<script>
import { findSearchWordSplitted } from '../../../../libraries/common'
export default {
  noExport: true,
  props: ['item', 'searchWord'],
  computed: {
    splitted() {
      return findSearchWordSplitted(this.item.label || '', new RegExp(this.searchWord, 'gi'));
    },
    length() {
      return this.item.children?.length;
    },
  },
}
</script>

<style lang="scss" scoped>
.leaf {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100%;
}
</style>